module.exports = "<div class=\"dialog\" *ngIf=\"opened\">\n    <div class=\"paper-header\" *ngIf=\"heading\">{{heading}}</div>\n    <div class=\"paper-content\">\n        <ng-content></ng-content>\n    </div>\n    <div class=\"buttons\">\n        <pbutton (click)=\"close()\">Close</pbutton>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/polymer/paper-dialog/paper-dialog.component.html
// module id = ./src/app/components/polymer/paper-dialog/paper-dialog.component.html
// module chunks = main